// src/utils/useImplantMode.js
import { useEffect, useState } from 'react';
import { isImplantMode, IMPLANT_EVENT } from './implantFilter';

// Re-renders the component whenever the Implant button is switched.
const useImplantMode = () => {
  const [on, setOn] = useState(isImplantMode());

  useEffect(() => {
    const update = () => setOn(isImplantMode());
    window.addEventListener(IMPLANT_EVENT, update);
    return () => window.removeEventListener(IMPLANT_EVENT, update);
  }, []);

  return on;
};

export default useImplantMode;